import { ButtonHTMLAttributes } from "react";
import { FiCheck, FiSave, FiSend } from "react-icons/fi";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  variant?: "primary" | "success" | "comment";
  icon?: "check" | "save" | "send" | "none";
}

export function FormButton({
  title,
  variant = "primary",
  icon = "none",
  disabled,
  ...rest
}: ButtonProps) {
  const variants = {
    primary:
      "bg-gradient-to-r from-[#0085BD] to-[#00a6e8] hover:from-[#006d9c] hover:to-[#0085BD] shadow-lg shadow-[#0085BD]/30 hover:shadow-xl hover:shadow-[#0085BD]/40",
    success:
      "bg-gradient-to-r from-emerald-500 to-green-400 hover:from-emerald-600 hover:to-emerald-500 shadow-lg shadow-emerald-500/30 hover:shadow-xl hover:shadow-emerald-500/40",
    comment:
      "bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 shadow-lg shadow-indigo-500/30 hover:shadow-xl hover:shadow-indigo-500/40",
  };

  const icons = {
    check: <FiCheck className="w-5 h-5" />,
    save: <FiSave className="w-5 h-5" />,
    send: <FiSend className="w-5 h-5" />,
    none: null,
  };

  return (
    <button
      className={`w-full mt-4 min-h-[56px] text-sm font-semibold text-white rounded-xl ${
        disabled
          ? "bg-gray-400 cursor-not-allowed opacity-60"
          : variants[variant] + " transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
      } flex items-center justify-center gap-2`}
      disabled={disabled}
      {...rest}
    >
      {icons[icon]}
      {title}
    </button>
  );
}
